import { CalendarClockIcon } from '@hugeicons/core-free-icons';
import { getLicensePeriodProgress } from '../../lib/licensePeriod';
import { HugeIcon } from '../ui/HugeIcon';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { SegmentedMeter } from './SegmentedMeter';

export function LicensePeriodCard({ expiryDate, startDate }: { expiryDate?: string; startDate?: string | null }) {
  const period = getLicensePeriodProgress(startDate, expiryDate);

  return (
    <Card className="relative gap-3 overflow-hidden rounded-[14px] bg-white py-3 before:pointer-events-none before:absolute before:inset-0 before:opacity-30 before:[background-image:linear-gradient(135deg,rgba(15,23,42,0.025)_1px,transparent_1px)] before:[background-size:12px_12px]" size="sm">
      <CardHeader className="relative px-3">
        <CardTitle className="flex items-center gap-2 text-[13px] font-medium">
          <span className="flex size-7 shrink-0 items-center justify-center rounded-lg bg-violet-500/14 text-violet-700">
            <HugeIcon icon={CalendarClockIcon} size={15} strokeWidth={1.9} />
          </span>
          License period
        </CardTitle>
      </CardHeader>
      <CardContent className="relative px-3">
        <div className="mb-2 flex items-center justify-between gap-2 text-xs">
          <span className="text-muted-foreground">Time remaining</span>
          <span className="font-semibold tabular-nums">{period.label}</span>
        </div>
        <SegmentedMeter ariaLabel={`${period.percent}% of the license period remaining`} colorClassName="bg-violet-600" ratio={period.percent / 100} segmentCount={20} />
        <p className="mt-2 truncate text-[11px] text-muted-foreground">{startDate ?? 'Not set'} — {expiryDate ?? 'Not set'}</p>
      </CardContent>
    </Card>
  );
}
